import ErrorCode from "../exception/ErrorCode";
import Immutable from "../immutable/Immutable";

/**
 * Globally used {@link Message} variables
 */
export interface MessageGlobals {
	messages: Immutable<Array<MessageInterface>>;
}

/**
 * Initialize the {@link MessageGlobals}. To be used in a components state.
 */
export function initMessageGlobals(): MessageGlobals {
	return {
		messages: Immutable.from([] as Array<MessageInterface>)
	};
}

/**
 * The different types of a {@link Message}
 */
export enum MessageType {
	SUCCESS = "success",
	INFO = "info",
	HELP = "help",
	WARNING = "warning",
	DANGER = "danger"
}

/**
 * the interface for a {@link Message}
 */
export interface MessageInterface {
	id: string;
	type: MessageType;
	message: string;
	visible: boolean;
	date: Date;
	code?: ErrorCode | number;
	context?: any;
}